// removed by extract-text-webpack-plugin
module.exports = {"Calendar":"Calendar__Calendar__2-bcp","Day":"Calendar__Day__1SjxJ","DayNum":"Calendar__DayNum__1poV8","DayName":"Calendar__DayName__N72gW","Header":"Calendar__Header__1MJaU","ArrowMonth":"Calendar__ArrowMonth__1yKmK","MonthLabel":"Calendar__MonthLabel__32Qi2","Row":"Calendar__Row__3z94w","Today":"Calendar__Today__1JMAi","Tomorrow":"Calendar__Tomorrow__3LN0F","Disabled":"Calendar__Disabled__1siHS","DifferentMonth":"Calendar__DifferentMonth__1fgI-","IsNotVisible":"Calendar__IsNotVisible__1ncnx","Selected":"Calendar__Selected__2DlqH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Calendar/Calendar.css
// module id = 182
// module chunks = 0